module.exports = __webpack_public_path__ + "static/media/flow-instructions.c95c4da3.webp";